import { DASHBOARD_USER_ROLES, usStatesAbreviated } from "../constants";
import moment from "moment";
import firebase from "firebase/compat/app";
import { getFirebaseAuthToken } from "../helpers/firebase_helper";

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const getCodeText = (role) => {
  switch (role) {
    case DASHBOARD_USER_ROLES.GA:
      return "National Code: ";
    case DASHBOARD_USER_ROLES.BROKER:
      return "GA Code: ";
    case DASHBOARD_USER_ROLES.EMPLOYER:
      return "Broker Code: ";
    default:
      return "";
  }
};

export const formatDate = (date) => {
  if (!date) {
    return null;
  }
  return moment.utc(date).format("MM/DD/YYYY");
};
export const formatEffectiveDate = (date) => {
  if (!date) {
    return null;
  }

  return moment.utc(date).subtract(1, "days").format("MM/DD/YYYY");
};

export const formatInvoiceDueDateFromEffectiveDate = (date) => {
  if (!date) {
    return null;
  }


  return moment.utc(date).subtract(1, "days").date(20).format("MM/DD/YYYY");
}

export const formatDateForInvoice = (dateString) => {
  // Use moment instead

  // Format: 08 Mar, 2024 3:09 AM
  return moment.utc(dateString).format("DD MMM, YYYY");
};

export const formatTimeForInvoice = (dateString) => {
  // Use moment instead
  return moment.utc(dateString).format("h:mm A");
};

export const parsedInvoiceAmount = (amount) => {
  return (parseInt(amount, 10) / 100).toFixed(2);
};

export const formatMonthAndYear = (dateString) => {
  return moment.utc(dateString).format("MMMM - YYYY");
};

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== "string") return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPhoneNumber = (phoneNumber) => {
  const stringNumber = String(phoneNumber);

  const cleanNumber = stringNumber.replace(/\D/g, "");

  let formattedNumber;
  switch (cleanNumber.length) {
    case 7:
      formattedNumber = cleanNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
      break;
    case 8:
      formattedNumber = cleanNumber.replace(
        /(\d{2})(\d{3})(\d{3})/,
        "$1-$2-$3"
      );
      break;
    case 9:
      formattedNumber = cleanNumber.replace(
        /(\d{3})(\d{3})(\d{3})/,
        "$1-$2-$3"
      );
      break;
    case 10:
      formattedNumber = cleanNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "($1)-$2-$3"
      );
      break;
    default:
      formattedNumber = cleanNumber;
  }

  return formattedNumber;
};

export const getAbreviatedState = (state) => {
  const stateObj = usStatesAbreviated.find((usState) => usState.name === state);
  return stateObj?.abbreviation || '';
};

export const getStatusEmployees = (isTerminated, isPending) => {
  if (isTerminated) {
    return "terminated";
  } else if (isPending) {
    return "pending";
  } else {
    return "active";
  }
};
export const getLabelForActiveTab = (activeTab) => {
  switch (activeTab) {
    case "1":
      return "active";
    case "3":
      return "pending";
    case "2":
      return "terminated";
    default:
      return "";
  }
};

export const formatIndexLabelCollapse = (sec) => {
  let numbers = sec.split(".").map(Number);
  for (let i = 0; i < numbers.length - 1; i++) {
    numbers[i] += 1;
  }
  return numbers.join(".");
};

export const getNextBillingDate = () => {
  const today = moment();
  const billingDayOfMonth = 20;

  if (today.date() >= billingDayOfMonth) {
    return today.add(1, "months").date(billingDayOfMonth).format("MM/DD/YYYY");
  } else {
    return today.date(billingDayOfMonth).format("MM/DD/YYYY");
  }
};

export const getNextCoverageDate = () => {
  const today = moment();
  const billingDayOfMonth = 20;

  if (today.date() >= billingDayOfMonth) {
    return today.add(1, "months").date(billingDayOfMonth).format("MM/DD/YYYY");
  } else {
    return today.date(billingDayOfMonth).format("MM/DD/YYYY");
  }
}

export const getNextBillingDatePlusOneMonth = () => {
  const nextBillingDate = getNextBillingDate();

  return moment(nextBillingDate).add(1, "months").format("MM/DD/YYYY");

}

// Function to change the color to darken in particlesAuth
export function darken(color, percent) {
  const f = parseInt(color.slice(1), 16),
    t = 0,
    p = Math.abs(percent) / 100,
    R = f >> 16,
    G = (f >> 8) & 0x00ff,
    B = f & 0x0000ff;
  return (
    "#" +
    (
      0x1000000 +
      Math.max(0, Math.min(255, R - Math.round(255 * p))) * 0x10000 +
      Math.max(0, Math.min(255, G - Math.round(255 * p))) * 0x100 +
      Math.max(0, Math.min(255, B - Math.round(255 * p)))
    )
      .toString(16)
      .slice(1)
  );
}

// Tokens and login
export const getTokenForAdmin = async () => {
  const token = await getFirebaseAuthToken();
  return token;
};

export const authenticateWithTokenUser = async () => {
  const tokenUser = localStorage.getItem("tokenUser");
  if (tokenUser) {
    try {
      await firebase.auth().signInWithCustomToken(tokenUser);
      return true;
    } catch (error) {
      console.log("error", error);
      localStorage.removeItem("tokenUser");
      return false;
    }
  }
};

export const authenticateWithTokenAdmin = async () => {
  const adminToken = localStorage.getItem("adminToken");
  if (adminToken) {
    try {
      localStorage.removeItem("tokenUser");
      await firebase.auth().signInWithCustomToken(adminToken);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
};

export const getAbbreviatedUsState = (state) => {
  const stateObj = usStatesAbreviated.find((usState) => usState.name === state);
  return stateObj?.abbreviation || "";
}

export const formatCentsToDollars = (cents) => {
  return (cents / 100).toFixed(2);
}

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();

  // Clean up
  window.URL.revokeObjectURL(url);
  a.remove();
}


export const getBaseUrl = () => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

// utils/themeUtils.js
export const canUserEditTheme = (currentUser, theme) => {
  if (!currentUser || !theme) {
    return false;
  }

  const { role } = currentUser;

  // Nationals can always edit their theme
  if (role === DASHBOARD_USER_ROLES.NATIONAL) {
    return true;
  }

  // For other roles, we need to check if the theme is their own
  // and if their parent allows override
  const isOwnTheme = theme.ownerId === currentUser.id;

  // GA can edit if:
  // 1. It's their own theme, OR
  // 2. They don't have a theme yet AND their National allows override
  if (role === DASHBOARD_USER_ROLES.GA) {
    if (isOwnTheme) {
      return true;
    }

    // If using National's theme, check if National allows override
    if (
      // theme.ownerType === DASHBOARD_USER_ROLES.NATIONAL && 
      theme.allowOverride) {
      return true;
    }

    return false;
  }

  // Broker can edit if:
  // 1. It's their own theme, OR
  // 2. They don't have a theme yet AND their GA allows override
  if (role === DASHBOARD_USER_ROLES.BROKER) {
    if (isOwnTheme) {
      return true;
    }

    // If using GA's theme (or National's through GA), check if that theme allows override
    if (theme.allowOverride) {
      return true;
    }

    return false;
  }

  // Employers and Individuals cannot edit themes
  return false;
};

export const getEntityProfileLink = (entityId, role) => {
  if (!entityId || !role) {
    return "";
  }

  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3001";

  switch (role) {
    case DASHBOARD_USER_ROLES.NATIONAL:
      return `/national/${entityId}`;
    case DASHBOARD_USER_ROLES.GA:
      return `/ga/${entityId}`;
    case DASHBOARD_USER_ROLES.BROKER:
      return `/brokers/${entityId}`;
    case DASHBOARD_USER_ROLES.EMPLOYER:
      return `/employer/${entityId}`;
    case DASHBOARD_USER_ROLES.INDIVIDUAL:
      return `/individual/${entityId}`;
    default:
      return "";
  }
}